// src/routes/waypoint/$sessionId.tsx

import { useNavigate, useParams } from "@tanstack/react-router";
import { useState } from "react";
import { BriefScreen } from "@/components/waypoint/BriefScreen";
import { CallScreen } from "@/components/waypoint/CallScreen";
import { useWaypointSession } from "@/hooks/use-waypoint-sessions";

type Phase = "brief" | "call";

export function WaypointCallPage() {
  const { sessionId } = useParams({ strict: false });
  const navigate = useNavigate();
  const [phase, setPhase] = useState<Phase>("brief");
  const [notes, setNotes] = useState("");
  const [micStream, setMicStream] = useState<MediaStream | undefined>(undefined);

  const { data: session, isLoading } = useWaypointSession(sessionId);

  function handleReady(noteText: string, stream: MediaStream | undefined) {
    setNotes(noteText);
    setMicStream(stream);
    setPhase("call");
  }

  function handleEnded() {
    navigate({
      to: "/dashboard/waypoint/$sessionId/debrief",
      params: { sessionId: sessionId ?? "" },
    });
  }

  if (isLoading || !session) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-indigo-500 border-t-transparent animate-spin" />
      </div>
    );
  }

  if (phase === "brief") {
    return <BriefScreen session={session} onReady={handleReady} />;
  }

  return <CallScreen session={session} onEnded={handleEnded} notes={notes} micStream={micStream} />;
}
